// src/components/Footer.js
import React from 'react';
import { Link } from 'react-router-dom';
import logo from '../assets/logo.png';
import './Footer.css'; // Importa o novo arquivo de estilo

const Footer = () => {
  const contactEmail = "contato@primotradesolutions.com.br";
  const contactPhone = "+55 11 9 7721-1739";
  const fullCompanyName = "Primo Trade Solutions LTDA";

  return (
    <footer className="main-footer">
      <div className="container">

        {/* --- COLUNA 1: SOBRE --- */}
        <div className="footer-column footer-about">
          <img src={logo} alt="Logo da Primo Trade Solutions" className="logo-image-footer" />
          <p>PTS Primo Trade Solutions LTDA - Soluções em tecnologia e segurança para residências, condomínios e empresas.</p>
        </div>

        {/* --- COLUNA 2: SOLUÇÕES E PRODUTOS --- */}
        <div className="footer-column footer-links">
          <h4>Soluções</h4>
          <ul>
            <li><Link to="/solucoes/para-seu-condominio">Para seu Condomínio</Link></li>
            <li><Link to="/para-seu-negocio">Para seu Negócio</Link></li>
            <li><Link to="/solucoes/carregadores-veiculares">Carregadores Veiculares</Link></li>
            <li><Link to="/solucoes/poste-cftv">Poste CFTV</Link></li>

            <li><Link to="/paineis-de-led">Painéis de LED</Link></li>
            <li><Link to="/servicos">Solicitar Orçamento de Serviços</Link></li>
          </ul>
           <h4 style={{marginTop: '20px'}}>Produtos</h4>
           <ul>
            <li><Link to="/produtos/intelbras">Produtos Intelbras</Link></li>
            <li><Link to="/carrinho">Carrinho de Compras</Link></li>
          </ul>
        </div>

        {/* --- COLUNA 3: CONTATO E INFORMAÇÕES --- */}
        <div className="footer-column footer-contact">
            <h4>Contato e Informações</h4>
            <p><strong>WhatsApp:</strong> {contactPhone}</p>
            <p><strong>E-mail:</strong> {contactEmail}</p>
            <p><strong>Matriz (SP):</strong> Rua Eugene Carriere, 30, CJ 06 T1 - São Paulo/SP - CNPJ: 42.419.988/0001-78</p>
            <p><strong>Filial (SC):</strong> Rua Dr. Pedro Ferreira, 333, Sala 1206 - Itajaí/SC - CNPJ: 42.419.988/0002-59</p>
        </div>

      </div>
      <div className="footer-bottom">
        <div className="container">
          <p>© {new Date().getFullYear()} {fullCompanyName}. Todos os direitos reservados.</p>
          <div className="bottom-links">
            <Link to="/politica-de-privacidade">Política de Privacidade</Link>
            <Link to="/termos-e-condicoes">Termos e Condições</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;